export default "__VITE_ASSET__BMBm0FRL__"